// src/components/Portfolio.js
import React, { useState } from 'react';

// --- Main Projects Data ---
const mainProjects = [
  {
    id: 1,
    title: "Hybrid Hosting",
    description: "My personal brainchild, a hosting company working on innovative solutions in the hosting space.",
    image: "../../vendor/hybridhosting.png",
    link: "https://hybridhosting.co",
    skills: ["Business Development", "IT Infrastructure Management", "Software Development", "Sales & Customer Acquisition", "Financial Planning & Pricing Strategy", "Marketing & Branding", "Technical Support & Client Relations", "AI & Automation Integration"]
  },
  {
    id: 2,
    title: "Pierce Technology Solutions LLC",
    description: "Kentucky-based managed service provider specializing in connectivity and security for horse farms, homes, and businesses. From foaling stall monitoring to farm-wide Wi-Fi and weather-ready camera systems.",
    image: "../../vendor/piercetechsolutions.png",
    link: "https://piercetechnologysolutions.com/",
    skills: ["Managed Connectivity & Networking", "Physical Security Systems", "Foaling & Stall Monitoring", "Camera Installation & Configuration", "Wi-Fi Design & Deployment", "ISP Integration & Backup Solutions", "Remote Access Setup", "On-Site Hardware Installation"]
  },
  {
    id: 3,
    title: "UpPacket",
    description: "A brand new project! In development for over 2 years and planned for release in late 2026!",
    image: "../../vendor/uppacket.png",
    link: "https://uppacket.com/",
    skills: ["Software Development", "Networking & Infrastructure", "AI & Automation Integration", "Market Research & Competitive Analysis", "Sales & Customer Acquisition", "API Development & Integration", "UI/UX Design", "Cloud & Edge Computing"]
  },
  { // --- NEW BarnBills Project ---
    id: 4, // Assigning ID 4
    title: "BarnBills",
    description: "BarnBills: Horse Farm Billing made simple. This revolutionary system is preparing for launch. Stay tuned!",
    image: "../../vendor/barnbills.png", // <<<--- UPDATE THIS IMAGE PATH
    link: "https://barnbills.com",
    skills: [
        "Software Development",
        "UI/UX Design",
        "Billing Systems & Logic",
        "Database Management",
        "Cloud Infrastructure",
        "Project Management",
        "Customer Onboarding",
        "Payment Gateway Integration"
      ]
  },
  {
    id: 5,
    title: "The Provider Podcast",
    description: "Demystifying tech buzzwords like AI, Cloud, and infrastructure with clear, human explanations.",
    image: "../../vendor/theproviderpodcast.png",
    link: "https://theproviderpodcast.net",
    skills: ["Content Creation & Strategy", "Audio Production & Editing", "Marketing & Branding", "Guest Outreach & Networking", "SEO & Audience Growth", "Public Speaking & Communication", "Project Management", "AI & LLM Expertise", "Simplification of Complex Topics"],
    variant: "compact"
  },
];

// --- Archived Projects Data ---
const archivedProjects = [
 {
    // Using a different ID for uniqueness across all projects if ever merged
    id: 101, // Changed ID from 4 to avoid potential key conflicts if arrays merge later
    title: "PiCollector",
    description: "Helping developers effortlessly collect and refine training data for self-driving applications.",
    image: "../../vendor/picollector.png",
    link: "https://github.com/KobyPierce/PiCollector/",
    skills: ["Machine Learning & Data Collection", "Embedded Systems Development", "Software Development", "Networking & Connectivity", "Real-Time Data Processing", "UI/UX Design", "Automation & Scripting", "Computer Vision Integration", "Edge AI Deployment"]
  },
  // --- Add more archived projects here in the future ---
];


const Portfolio = () => {
  // State to control the visibility of the archived projects modal
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <section id="work" className="py-12 md:py-16">
      <h2 className="text-2xl font-bold text-white text-center mb-4">My Projects</h2>
      {/* Display Main Projects */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {mainProjects.map(project => (
          <ProjectCard key={project.id} project={project} />
        ))}
      </div>

      {/* Archived Projects Button */}
      <div className="text-center mt-10 hidden">
        <button
          onClick={openModal}
          className="text-gray-300 hover:text-white border border-gray-600 hover:border-gray-400 px-6 py-2 rounded transition duration-300 ease-in-out text-sm"
        >
          Archived Projects
        </button>
      </div>

      {/* Archived Projects Modal */}
      {isModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-4 transition-opacity duration-300"
          onClick={closeModal}
        >
          <div
            className="bg-[#181818] rounded-lg p-6 md:p-8 max-w-4xl w-full max-h-[90vh] overflow-y-auto relative shadow-xl"
            onClick={e => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={closeModal}
              className="absolute top-4 right-4 text-gray-400 hover:text-white text-3xl leading-none font-semibold z-10"
              aria-label="Close modal"
            >
              &times;
            </button>

            {/* Modal Title & Subtitle */}
            <h3 className="text-2xl font-bold text-white text-center mb-2">Archived Projects</h3>
            <p className="text-gray-400 text-center mb-8">Unfinished ideas waiting for their time.</p>

            {/* Archived Projects Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {archivedProjects.map(project => (
                <ProjectCard key={project.id} project={project} />
              ))}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

// --- ProjectCard Component (Unchanged from previous version) ---
const ProjectCard = ({ project }) => {
  const [hovered, setHovered] = useState(false);
  const isCompact = project.variant === "compact";

  const handleMouseMove = (e) => {
  };

  const customCursorUrl =
    "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='32' height='32'%3E%3Ccircle cx='16' cy='16' r='6' fill='white' stroke='white' stroke-width='1'/%3E%3C/svg%3E";

  return (
    <a
      href={project.link}
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => {
        setHovered(false);
      }}
      onMouseMove={handleMouseMove}
      className={`relative block overflow-hidden rounded-md transition-transform duration-300 group bg-[#212121] ${isCompact ? "md:col-span-2 flex items-start px-6 py-5 gap-5 min-h-[180px]" : ""}`}
      style={{
        transform: hovered ? "scale(1.03)" : "scale(1)",
        cursor: hovered ? `url("${customCursorUrl}") 16 16, pointer` : "pointer",
      }}
    >
      {isCompact ? (
        <>
          {project.image && (
            <div className="w-64 h-40 rounded-md overflow-hidden bg-[#2a2a2a] flex-shrink-0 shadow-inner">
              <img
                src={project.image}
                alt={project.title}
                className="w-full h-full object-cover"
              />
            </div>
          )}
          <div className="flex-1 min-w-0">
            <h3 className="text-lg font-bold text-white mb-2">{project.title}</h3>
            {project.description && (
              <p className="text-gray-300 text-sm leading-tight mb-3">
                {project.description}
              </p>
            )}
            {project.skills && project.skills.length > 0 && (
              <div className="flex flex-wrap gap-2">
                {project.skills.map((skill, index) => (
                  <div
                    key={index}
                    className="bg-[#333333] text-gray-200 text-xs px-2 py-1 rounded"
                  >
                    {skill}
                  </div>
                ))}
              </div>
            )}
          </div>
          <span className="text-sm text-gray-400 transition-colors duration-300 group-hover:text-white flex-shrink-0">
            Visit site ->
          </span>
        </>
      ) : (
        <>
          <div className="relative">
            <img
              src={project.image}
              alt={project.title}
              className={`w-full h-48 object-cover transition-all duration-300 ${hovered ? "blur-sm scale-105" : ""}`}
            />
            <div
              className={`absolute inset-0 flex items-center justify-center transition-opacity duration-300 ${hovered ? "opacity-100" : "opacity-0"}`}
              style={{ backgroundColor: "rgba(0, 0, 0, 0.6)" }}
            >
              <span className="text-white text-lg font-bold px-4 text-center">Take me to {project.title}</span>
            </div>
          </div>
          <div className="p-4">
            <h3 className="text-xl font-bold text-white mb-2">{project.title}</h3>
            <p className="text-gray-300 text-sm mb-4">{project.description}</p>
            {project.skills && project.skills.length > 0 && (
              <div className="flex flex-wrap gap-2">
                {project.skills.map((skill, index) => (
                  <div
                    key={index}
                    className="bg-[#333333] text-gray-200 text-xs px-2 py-1 rounded"
                  >
                    {skill}
                  </div>
                ))}
              </div>
            )}
          </div>
        </>
      )}
    </a>
  );
};


export default Portfolio;